<template>
  <v-container>
      <actual-planning-list link-active></actual-planning-list>
  </v-container>
</template>
<script>
import ActualPlanningList from "@/components/ActualPlanningList";

export default {
  name: "Planning",
  components: {
    ActualPlanningList
  }
};
</script>
